import { track } from '@tandemone/observability/browser'
import { EVENTS } from '@tandemone/types'
import { useEffect } from 'react'

const KEY = 'tandemone:lastSeenAt'
const THRESHOLD_DAYS = 7

/** tracks `user_returned` once per page-load when the gap since localStorage
 * `lastSeenAt` exceeds 7 days. first-ever visit doesn't fire (no prior
 * timestamp to compare against).
 */
export function useReturnDetection(): void {
  useEffect(() => {
    const last = localStorage.getItem(KEY)
    const now = Date.now()
    localStorage.setItem(KEY, String(now))

    if (!last) return
    const days = (now - Number(last)) / (1000 * 60 * 60 * 24)
    if (days >= THRESHOLD_DAYS) {
      track(EVENTS.USER_RETURNED, {
        days_since_last_session: Math.round(days)
      })
    }
  }, [])
}
